import React from 'react';
import { useLocation } from 'react-router-dom';
import Services from '../../components/Services';
import WhyFixinn from '../../components/WhyFixinn';
import CTA from '../../components/CTA';
import Testimonials from '../../components/Testimonials';
import ContactUs from '../../components/ContactUs';
import '../../components/CSS/Home.css';
import HeroSlider from '../../components/HeroSlider';
import SEOHead from '../../components/SEO/SEOHead';
import { seoConfig } from '../../components/SEO/seoConfig';
import { websiteSchema, organizationSchema, createBreadcrumbSchema } from '../../components/SEO/schemas';

const Home = () => {
  const location = useLocation();
  const isServicesPage = location.pathname === '/services';

  // Determine which SEO config to use
  const currentSeoConfig = isServicesPage ? seoConfig.services : seoConfig.home;

  // Set up breadcrumbs for services page
  const breadcrumbs = isServicesPage ? [
    { name: 'Home', url: process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk' },
    { name: 'Services', url: `${process.env.REACT_APP_SITE_URL || 'https://fixinn.co.uk'}/services` }
  ] : [];

  const combinedSchema = isServicesPage
    ? [websiteSchema, organizationSchema, createBreadcrumbSchema(breadcrumbs)]
    : [websiteSchema, organizationSchema];

  return (
    <>
      {/* <SEOHead
        title={currentSeoConfig.title}
        description={currentSeoConfig.description}
        keywords={currentSeoConfig.keywords}
        canonical={currentSeoConfig.canonical}
        ogTitle={currentSeoConfig.ogTitle}
        ogDescription={currentSeoConfig.ogDescription}
        ogImage={currentSeoConfig.ogImage}
        ogUrl={currentSeoConfig.canonical}
        twitterTitle={currentSeoConfig.twitterTitle}
        twitterDescription={currentSeoConfig.twitterDescription}
        structuredData={combinedSchema}
      /> */}
      <div className="home-page">
        <HeroSlider />
        <Services />
        <WhyFixinn />
        <CTA />
        <Testimonials />
        <ContactUs />
      </div>
    </>
  );
};

export default Home;
